import React, { memo, PropsWithChildren, useCallback, useEffect } from 'react'
import { ViewType } from '../assets/constants'
import StockBar from './home/stockBar/stockBar'
import { useStyles } from './homeLayoutStyles'
import { Button, Stack, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectPrimarySecurity } from '../selectors/home'
import { isFnOSecurity, getPathForSecurity } from '../util/security'
import commonActions from '../actions/common.actions'
import { useDispatch } from 'react-redux'
import { selectIsEmbedded } from '../selectors/device'

export type HomeLayoutProps = PropsWithChildren & {
    view: ViewType,
    error?: string
}

const HomeLayout: React.FC<HomeLayoutProps> = ({ view, error, children }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { classes, cx } = useStyles()
    const theme = useTheme()
    const { expressionMode, primary, underlying } = useSelector(selectPrimarySecurity)
    const selectedSecurity = expressionMode ? null : (primary && isFnOSecurity(primary) ? underlying : primary)
    const isEmbedded = useSelector(selectIsEmbedded)

    useEffect(() => {
        if (selectedSecurity) {
            commonActions.setNavigationUrl(dispatch, {
                viewType: view,
                url: getPathForSecurity(view, selectedSecurity)
            })
        }
    }, [dispatch, selectedSecurity, view])

    return <div style={{ gridArea: 'main-content' }} className={cx(classes.container, 'main-content')}>{
        error ?
            (
                <Stack className={'empty-view'} justifyContent={'center'} alignItems={'center'} direction={'column'}
                    spacing={1}>
                    <Typography variant={'body1'}>{error}</Typography>
                    <Button variant="outlined" color={'inherit'} onClick={() => {
                        navigate({
                            pathname: '/',
                            search: ''
                        }, {
                            replace: true
                        })
                        window.location.reload()
                    }}>Go To Home</Button>
                </Stack>) : (
                <>
                    {!isEmbedded && <StockBar
                        viewType={view}
                        ivPlotTimeBucket={view === ViewType.OPEN_INTEREST}
                    />}
                    <div style={view === ViewType.AUTOMATION ? { gridArea: 'content', overflow: 'auto', background: theme.palette.background.paper } : { gridArea: 'content' }}>
                        {children}
                    </div>
                </>)
    }
    </div>
}


export default memo(HomeLayout)